import { ref, reactive, readonly } from 'vue';
import type { ReportType, ReportKindItem } from './types';

const reportMap = readonly<ReportKindItem[]>([
  {
    // 信贷
    label: '风险报告-消金版',
    key: 8,
    theme: {
      primaryColor: 'rgb(28, 105, 255)',
      bgColor: 'rgb(133, 182, 255)',
      navBgColor: 'rgb(201, 223, 255)',
      bgImg: 'credit',
    },
    buriedOpeion: {
      dataName: '风险报告-消金版',
      pageName: 'HP1000',
    },
  },
  {
    label: '风险报告-机构版',
    key: 1,
    theme: {
      primaryColor: 'rgb(28, 105, 255)',
      bgColor: 'rgb(133, 182, 255)',
      navBgColor: 'rgb(201, 223, 255)',
      bgImg: 'risk',
    },
    buriedOpeion: {
      dataName: '风险报告-机构版',
      pageName: 'HP1000',
    },
  },
  {
    label: '婚恋报告',
    key: 2,
    theme: {
      primaryColor: 'rgb(252, 95, 123)',
      bgColor: 'rgb(255, 208, 218)',
      navBgColor: 'rgb(255, 230, 236)',
      bgImg: 'marriage',
    },
    buriedOpeion: {
      dataName: '婚恋报告',
      pageName: 'HP1001',
    },
  },
  {
    label: '家政报告',
    key: 3,
    theme: {
      primaryColor: 'rgb(18, 198, 141)',
      bgColor: 'rgb(162, 231, 210)',
      navBgColor: 'rgb(218, 245, 236)',
      bgImg: 'home',
    },
    buriedOpeion: {
      dataName: '家政报告',
      pageName: 'HP1002',
    },
  },
  {
    label: '企业报告',
    key: 4,
    theme: {
      primaryColor: 'rgb(77, 84, 255)',
      bgColor: 'rgb(185, 179, 255)',
      navBgColor: 'rgb(204, 199, 255)',
      bgImg: 'enterprise',
    },
    buriedOpeion: {
      dataName: '企业报告',
      pageName: 'HP1004',
    },
  },
  {
    label: '租赁报告',
    key: 5,
    theme: {
      primaryColor: 'rgb(25, 108, 255)',
      bgColor: 'rgb(133, 182, 255)',
      navBgColor: 'rgb(162, 199, 254)',
      bgImg: 'lease',
    },
    buriedOpeion: {
      dataName: '租赁报告',
      pageName: 'HP1003',
    },
  },
  {
    label: '司法报告',
    key: 7,
    theme: {
      primaryColor: 'rgb(28, 105, 255)',
      bgColor: 'rgb(133, 182, 255)',
      navBgColor: 'rgb(201, 223, 255)',
      bgImg: 'judicial',
    },
    buriedOpeion: {
      dataName: '司法报告',
      pageName: 'HP1000',
    },
  },
]);

export type ReportTypeListItem = { label: string; value: string | number };
export const getReportTypes = (
  opt: {
    exclude?: ReportKindItem['key'][];
    valueType?: 'string' | 'number';
  } = {}
) => {
  const { exclude = [], valueType = 'string' } = opt;
  const dataList: ReportTypeListItem[] = [];
  for (const item of reportMap) {
    if (exclude.includes(item.key)) continue;
    dataList.push({
      label: item.label,
      value: valueType === 'number' ? item.key : item.key.toString(),
    });
  }

  return dataList;
};

export const useReportKind = () => {
  const curReportKind = ref<Partial<ReportKindItem>>(readonly({}));
  const getCurReportKind = (reportType: ReportType) => {
    console.log({ reportType });
    const curData = reportMap.find((item) => item.key === Number(reportType));
    curData && (curReportKind.value = curData);
  };

  return { curReportKind, getCurReportKind };
};

export const getAllReportKey = (keyType: 'number' | 'string' = 'number') =>
  reportMap.map((item) => (keyType === 'number' ? item.key : item.key.toString()));
